function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Wallet_LOGOS-02",
  transform: "translate(-27.251 -25.402)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1871",
  "data-name": "Rectangle 1871",
  width: 8.66,
  height: 35.932,
  rx: 4.33,
  transform: "translate(42.815 50.177) rotate(-24.82)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1872",
  "data-name": "Rectangle 1872",
  width: 8.66,
  height: 33.615,
  rx: 4.33,
  transform: "translate(64.223 81.704) rotate(-176.71)",
  fill: "#fff",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1873",
  "data-name": "Rectangle 1873",
  width: 8.66,
  height: 33.58,
  rx: 4.33,
  transform: "translate(77.043 81.703) rotate(-176.71)",
  fill: "#fff",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1874",
  "data-name": "Rectangle 1874",
  width: 8.66,
  height: 35.932,
  rx: 4.33,
  transform: "translate(55.848 50.176) rotate(-24.82)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1730",
  "data-name": "Path 1730",
  d: "M56.622,26.8A39.2,39.2,0,0,0,28.645,54.752,40.147,40.147,0,0,0,67.3,105.495a37.567,37.567,0,0,0,17.431-4c4.6-2.4,1.014-9.365-4.4-6.333-3.8,2.129-8.4,2.728-13.035,2.728A32.507,32.507,0,0,1,36,56.7,31.653,31.653,0,0,1,58.559,34.147,32.56,32.56,0,0,1,98.907,72.858H88.9L78.561,50.478a4.34,4.34,0,0,0-5.745-2.114h0A4.34,4.34,0,0,0,70.727,54.1L82.176,78.856a4.8,4.8,0,0,0,4.147,2.621h14a5.379,5.379,0,0,0,5.116-3.716,39.2,39.2,0,0,0,1.257-4.944A40.054,40.054,0,0,0,56.622,26.8Z",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1731",
  "data-name": "Path 1731",
  d: "M52.4,219.025a4.69,4.69,0,0,1-1.389,3.351,4.842,4.842,0,0,1-1.521,1.014,4.649,4.649,0,0,1-1.856.375,4.735,4.735,0,0,1-3.174-1.212,4.563,4.563,0,0,1-1.455.9,4.826,4.826,0,0,1-1.7.309,4.61,4.61,0,0,1-1.851-.375,4.878,4.878,0,0,1-1.521-1.014,4.776,4.776,0,0,1-1.014-1.521,4.619,4.619,0,0,1-.375-1.846V211.1h3.174v7.925a1.557,1.557,0,0,0,.122.613,1.6,1.6,0,0,0,.34.507,1.521,1.521,0,0,0,.507.34,1.607,1.607,0,0,0,1.227,0,1.587,1.587,0,0,0,.507-.34,1.521,1.521,0,0,0,.345-.507,1.557,1.557,0,0,0,.122-.614V211.1h3.159v7.925a1.481,1.481,0,0,0,.132.614,1.6,1.6,0,0,0,.34.507,1.576,1.576,0,0,0,1.115.461,1.582,1.582,0,0,0,.619-.122,1.562,1.562,0,0,0,.507-.34,1.694,1.694,0,0,0,.34-.507,1.475,1.475,0,0,0,.127-.613V211.1h3.164Z",
  transform: "translate(-4.579 -91.546)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1732",
  "data-name": "Path 1732",
  d: "M83.74,223.039h-.766l-1.232-1.709a11.663,11.663,0,0,1-.958.761,7.424,7.424,0,0,1-1.065.639,6.336,6.336,0,0,1-1.146.416,4.711,4.711,0,0,1-1.191.152,6.885,6.885,0,0,1-2.469-.446,5.856,5.856,0,0,1-2.028-1.283,5.937,5.937,0,0,1-1.379-2.089A7.24,7.24,0,0,1,71,216.7a6.921,6.921,0,0,1,.507-2.667,6.16,6.16,0,0,1,3.387-3.443,6.4,6.4,0,0,1,2.469-.482,4.782,4.782,0,0,1,1.2.152,5.912,5.912,0,0,1,1.151.421,6.968,6.968,0,0,1,1.065.624,8.926,8.926,0,0,1,.968.776l1.232-1.475h.766ZM80.546,216.7a3.412,3.412,0,0,0-.248-1.262,3.621,3.621,0,0,0-.679-1.08A3.357,3.357,0,0,0,78.6,213.6a2.758,2.758,0,0,0-1.227-.284,3.423,3.423,0,0,0-1.227.223,2.788,2.788,0,0,0-1.014.649,3.042,3.042,0,0,0-.669,1.065,4,4,0,0,0-.243,1.445,4.056,4.056,0,0,0,.243,1.45,3.007,3.007,0,0,0,.669,1.06,2.8,2.8,0,0,0,1.014.654,3.417,3.417,0,0,0,1.227.218A2.692,2.692,0,0,0,78.6,219.8a3.275,3.275,0,0,0,1.014-.755,3.62,3.62,0,0,0,.684-1.08,3.372,3.372,0,0,0,.243-1.262Z",
  transform: "translate(-21.567 -91.058)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1733",
  "data-name": "Path 1733",
  d: "M104.1,218.691h-3.2v-17.4h3.2Z",
  transform: "translate(-36.308 -86.71)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1734",
  "data-name": "Path 1734",
  d: "M115.184,218.691H112v-17.4h3.194Z",
  transform: "translate(-41.78 -86.71)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1735",
  "data-name": "Path 1735",
  d: "M127.357,219.957a1.55,1.55,0,0,0,.37.076h.37a3.124,3.124,0,0,0,.9-.127,3.4,3.4,0,0,0,.806-.365,3.042,3.042,0,0,0,1.156-1.344l2.327,2.337a6.145,6.145,0,0,1-1.014,1.126,6.43,6.43,0,0,1-1.242.852,6.545,6.545,0,0,1-1.41.507,6.282,6.282,0,0,1-7.372-3.742,6.8,6.8,0,0,1-.507-2.647,7.037,7.037,0,0,1,.507-2.7,6.15,6.15,0,0,1,1.364-2.079,6.231,6.231,0,0,1,2.028-1.339,6.49,6.49,0,0,1,2.469-.477,6.382,6.382,0,0,1,1.521.188,6.561,6.561,0,0,1,1.41.532,6.455,6.455,0,0,1,1.252.857,6.348,6.348,0,0,1,1.014,1.131Zm1.622-6.546a1.961,1.961,0,0,0-.431-.1,3.275,3.275,0,0,0-.451-.025,3.224,3.224,0,0,0-1.227.238,2.936,2.936,0,0,0-1.014.679,3.174,3.174,0,0,0-.669,1.065,4.056,4.056,0,0,0-.223,1.795,4.468,4.468,0,0,0,.056.446,3.662,3.662,0,0,0,.1.436,1.566,1.566,0,0,0,.147.375Z",
  transform: "translate(-46.581 -91.023)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1736",
  "data-name": "Path 1736",
  d: "M153.1,218.691a5.435,5.435,0,0,1-2.165-.436,5.6,5.6,0,0,1-2.971-2.971,5.435,5.435,0,0,1-.436-2.165v-3.7H146v-3.159h1.521V201.29h3.164v4.974H155.5v3.159h-4.812v3.7a2.312,2.312,0,0,0,.188.938,2.413,2.413,0,0,0,2.221,1.47h2.4v3.164Z",
  transform: "translate(-58.541 -86.71)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1737",
  "data-name": "Path 1737",
  d: "M172.135,231.347a2.028,2.028,0,0,1-.152.786,1.911,1.911,0,0,1-.416.634,1.982,1.982,0,0,1-.629.421,1.886,1.886,0,0,1-.781.157,1.906,1.906,0,0,1-.771-.157,1.973,1.973,0,0,1-1.227-1.84,1.886,1.886,0,0,1,.157-.771,1.987,1.987,0,0,1,.431-.624,2.028,2.028,0,0,1,.639-.426,1.906,1.906,0,0,1,.771-.157,1.886,1.886,0,0,1,.781.157,2,2,0,0,1,.629.426,1.871,1.871,0,0,1,.416.624A1.973,1.973,0,0,1,172.135,231.347Z",
  transform: "translate(-69.466 -100.552)",
  fill: "#fff"
}));

function SvgWalletLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.139 107.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLogoWhite);
export default __webpack_public_path__ + "static/media/Wallet_LOGO_White.afbf0e91.svg";
export { ForwardRef as ReactComponent };